//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { CustomRawNodeDatum } from "models/propTypes/chartProps";
import { IconDefinition } from "models/propTypes/iconPropTypes";
//#endregion

function useTreeDataHandler(
  iconHandler?: (branchNode: WintSuperkollAPIModel.BranchNode) => IconDefinition | undefined
) {
  const apiBranchToTree = (branchNode: WintSuperkollAPIModel.BranchNode): CustomRawNodeDatum => {
    return {
      name: branchNode.leaf?.name ?? "",
      attributes: {
        description1: branchNode.leaf?.description1 ?? "",
        description2: branchNode.leaf?.description2 ?? "",
      },
      icon: iconHandler !== undefined ? iconHandler(branchNode) : undefined,
      children: branchNode.branches?.map((innerBranchNode): CustomRawNodeDatum => apiBranchToTree(innerBranchNode)),
    };
  };

  /* CustomRawNodeDatum generates for tree type graphs, and CustomRawNodeDatum[] generates for forest type graphs. */
  const apiToTreeDataHandler = (
    chartData?: WintSuperkollAPIModel.ReportWidget
  ): CustomRawNodeDatum[] | CustomRawNodeDatum => {
    const treeResults = chartData?.treeWidgetData;

    let treeData: CustomRawNodeDatum | CustomRawNodeDatum[];

    if (treeResults && treeResults.branches) {
      treeData = treeResults.branches.map((branchNode): CustomRawNodeDatum => apiBranchToTree(branchNode));
    } else {
      treeData = [];
    }

    return treeData;
  };

  return { apiToTreeDataHandler };
}

export default useTreeDataHandler;
